
import { IoPhonePortraitOutline ,IoGameControllerOutline,IoFootball} from 'react-icons/io5';
import { IoIosPeople } from 'react-icons/io';
import { BsHouse,BsAirplane  } from 'react-icons/bs';
import { PiMusicNotesLight ,PiGearSixBold ,PiTShirt,PiWrenchBold,PiCarProfile} from 'react-icons/pi';
import { RiFlowerLine,RiHeart3Line ,RiUserLine } from 'react-icons/ri';
import { TbGridDots } from 'react-icons/tb';
import { BiCategory } from 'react-icons/bi';
import { TbCalendarCheck } from 'react-icons/tb';
import { GoPlusCircle,GoMail } from "react-icons/go";
import { VscHome } from "react-icons/vsc";

export const CategorySvg = {
  'Alle Kategorien': <BiCategory />,
  'Auto & Motorrad': <PiCarProfile />,
  'Elektronik & Technik': <IoPhonePortraitOutline />,
  Events: <TbCalendarCheck />,
  'Familie, Kind & Baby': <IoIosPeople />,
  'Haus & Garten': <BsHouse />,
  'Maschinen & Geräte': <PiGearSixBold />,
  'Musik & Unterhaltung': <PiMusicNotesLight />,
  'Mode & Beauty': <PiTShirt />,
  'Spiele & Konsolen': <IoGameControllerOutline />,
  Sport: <IoFootball />,
  Wellness: <RiFlowerLine />,
  'Werkstatt & Werkzeug':<PiWrenchBold />,
  'Urlaub & Reisen': <BsAirplane />,
  Sonstiges: <TbGridDots />,
};
export const FooterNavItems = [
  { id: 1, icon: <VscHome />, route: '/' },
  { id: 2, icon: <RiHeart3Line />, route: '/listings' },
  { id: 3, icon: <GoPlusCircle />, route: '/l/new' },
  { id: 4, icon: <GoMail />, route: '/inbox' },
  { id: 5, icon: <RiUserLine  />, route: '/profile-settings' },
];